// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const RedhatIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 24 24">
    <path
      fill="#E00"
      d="M15.68 13.6c1.45 0 3.54-.3 3.54-2.03q0-.2-.04-.4l-.85-3.74c-.2-.82-.37-1.2-1.82-1.92C15.4 4.94 12.95 4 12.23 4c-.69 0-.88.87-1.68.87-.78 0-1.34-.65-2.07-.65-.7 0-1.14.47-1.5 1.44 0 0-.96 2.74-1.09 3.15l-.02.22c-.01 1.06 4.18 4.55 9.81 4.57m3.76-1.32c.2.95.2 1.05.2 1.17 0 1.61-1.82 2.52-4.21 2.52-5.41 0-10.14-3.17-10.14-5.26q0-.45.17-.85C3.52 9.96 1 10.3 1 12.52c0 3.64 8.62 8.13 15.45 8.13 5.23 0 6.55-2.37 6.55-4.25 0-1.46-1.27-3.13-3.56-4.12"
    />
    <path
      fill="#000"
      d="M19.44 12.28c.2.95.2 1.05.2 1.17 0 1.61-1.82 2.52-4.21 2.52-5.41 0-10.14-3.17-10.14-5.26q0-.45.17-.85l.43-1.05-.02.22c0 1.06 4.2 4.55 9.81 4.55 1.45 0 3.54-.3 3.54-2.02q0-.2-.04-.4z"
    />
  </svg>,
  "Redhat",
);
export default RedhatIcon;
